var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFjd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2673C24 18.8947 18.6274 24.2673 12 24.2673C5.37262 24.2673 0 18.8947 0 12.2673C0 12.2702 12 0.268646 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 6.00952V10.0568L7.82422 6.00952H11.9981Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26 12.2716H9.78556L6.26 7.57593L5.73828 11.2281L6.26 12.2716Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 12.2682H11.999C11.999 12.2574 11.999 12.2469 11.999 12.2361C11.9883 12.2468 11.9776 12.2575 11.9668 12.2682Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.52819C12 4.41671 12 3.03319 12 0.267334H11.998C5.3715 0.268459 0 5.64057 0 12.2673H6.26086V8.74182L9.78642 12.2673H11.968C11.9787 12.2566 11.9894 12.246 12.0001 12.2352C12.0001 11.4268 12.0001 10.7054 12.0001 10.0538L8.47443 6.52819H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07222 1.83374C4.19539 2.90244 2.63511 4.46273 1.56641 6.33956V12.2685H4.69686V4.96429V4.9642H12.0012C12.0012 3.97687 12.0012 3.03627 12.0012 1.83374H6.07222Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 10.7925L7.73739 6.52905H6.26172V6.52915L12.0007 12.2681H12.0008C12.0008 12.2681 12.0008 11.2506 12.0008 10.7925Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5664 8.09597V12.2698C13.5664 15.0654 17.2186 15.922 17.2186 15.922C17.2186 15.922 20.8707 15.0654 20.8707 12.2698V8.09597L17.2186 7.05249L13.5664 8.09597Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8707 8.09426V6.52905H13.5664V8.09426H16.6968V11.2248H13.5664V12.2681C13.5664 12.2682 13.5664 12.2682 13.5664 12.2682L16.6968 12.2683V15.7603C17.0117 15.8717 17.2186 15.9204 17.2186 15.9204C17.2186 15.9204 17.4254 15.8718 17.7402 15.7603V12.2682H20.8707V12.2681V11.2247H17.7402V8.09421H20.8707V8.09426Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFjd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FJD.2f13087ed04d9592f3ee2786ab4dedd2.svg";